import { render, staticRenderFns } from "./bonusUI.vue?vue&type=template&id=780b335e&"
import script from "./bonusUI.vue?vue&type=script&lang=js&"
export * from "./bonusUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports